export const USER_STATUS_ACTIVE = 'active'
export const USER_STATUS_ARCHIVE = 'archive'
